/* assets/geolocation-modal.js */
document.addEventListener("DOMContentLoaded", function() {
  // If they already dismissed the modal in this session, don't bother them again
  if (sessionStorage.getItem('geo-modal-dismissed')) return;

  const workerUrl = 'https://where.bongeats.workers.dev/';
  const currentHost = window.location.hostname;
  
  fetch(workerUrl)
    .then(response => response.json())
    .then(data => {
      const userCountry = data.country;
      let showModal = false;
      let targetUrl = '';
      let messageHtml = '';

      // Dictionary of countries served by the Global site (US removed based on your target regions)
      const countries = { 
        'GB': { name: 'the UK', flag: '🇬🇧' },
        'CH': { name: 'Switzerland', flag: '🇨🇭' },
        
        // EU Countries
        'AT': { name: 'Austria', flag: '🇦🇹' },
        'BE': { name: 'Belgium', flag: '🇧🇪' },
        'BG': { name: 'Bulgaria', flag: '🇧🇬' },
        'HR': { name: 'Croatia', flag: '🇭🇷' },
        'CY': { name: 'Cyprus', flag: '🇨🇾' },
        'CZ': { name: 'the Czech Republic', flag: '🇨🇿' },
        'DK': { name: 'Denmark', flag: '🇩🇰' },
        'EE': { name: 'Estonia', flag: '🇪🇪' },
        'FI': { name: 'Finland', flag: '🇫🇮' },
        'FR': { name: 'France', flag: '🇫🇷' },
        'DE': { name: 'Germany', flag: '🇩🇪' },
        'GR': { name: 'Greece', flag: '🇬🇷' },
        'HU': { name: 'Hungary', flag: '🇭🇺' },
        'IE': { name: 'Ireland', flag: '🇮🇪' },
        'IT': { name: 'Italy', flag: '🇮🇹' },
        'LV': { name: 'Latvia', flag: '🇱🇻' },
        'LT': { name: 'Lithuania', flag: '🇱🇹' },
        'LU': { name: 'Luxembourg', flag: '🇱🇺' },
        'MT': { name: 'Malta', flag: '🇲🇹' },
        'NL': { name: 'the Netherlands', flag: '🇳🇱' },
        'PL': { name: 'Poland', flag: '🇵🇱' },
        'PT': { name: 'Portugal', flag: '🇵🇹' },
        'RO': { name: 'Romania', flag: '🇷🇴' },
        'SK': { name: 'Slovakia', flag: '🇸🇰' },
        'SI': { name: 'Slovenia', flag: '🇸🇮' },
        'ES': { name: 'Spain', flag: '🇪🇸' },
        'SE': { name: 'Sweden', flag: '🇸🇪' }
      };

      // SCENARIO 1: User is in India, but looking at the Global (.com) site
      if (currentHost.includes('bongeats.com') && userCountry === 'IN') {
        showModal = true;
        targetUrl = 'https://shop.bongeats.in' + window.location.pathname + window.location.search;
        messageHtml = 'Hi! It looks like you are visiting us from <span class="highlight-text">🇮🇳 India</span>. You might not be able to checkout on this website, so consider visiting the shop that serves your location.';
      } 
      // SCENARIO 2: User is visiting the India (.in) site, but is from one of your served Global regions (EU/UK/CH)
      else if (currentHost.includes('bongeats.in') && countries[userCountry]) {
        showModal = true;
        targetUrl = 'https://shop.bongeats.com' + window.location.pathname + window.location.search;
        const geoInfo = countries[userCountry];
        messageHtml = `Hi! It looks like you are visiting us from <span class="highlight-text">${geoInfo.flag} ${geoInfo.name}</span>. You might not be able to checkout on this website, so consider visiting the shop that serves your location.`;
      }

      // Render the modal if either condition is met
      if (showModal) {
        const overlay = document.getElementById('geo-modal-overlay');
        const modalText = document.getElementById('geo-modal-text');
        const redirectBtn = document.getElementById('geo-redirect-btn');
        const closeX = document.getElementById('geo-close-x');
        const closeBtn = document.getElementById('geo-close-btn');

        if (!overlay || !modalText || !redirectBtn) return;

        modalText.innerHTML = messageHtml;
        redirectBtn.href = targetUrl;

        const dismissModal = () => {
          overlay.classList.remove('active');
          sessionStorage.setItem('geo-modal-dismissed', 'true');
        };

        if (closeX) closeX.addEventListener('click', dismissModal);
        if (closeBtn) closeBtn.addEventListener('click', dismissModal);
        
        redirectBtn.addEventListener('click', () => {
          sessionStorage.setItem('geo-modal-dismissed', 'true');
        });

        overlay.classList.add('active');
      }
    })
    .catch(err => console.error('Error fetching geolocation data:', err));
});